import React, { useEffect } from 'react';
import {
  Routes,
  Route,
  useLocation,
  useNavigate
} from 'react-router-dom';

import './css/style.css';
import './charts/ChartjsConfig';

import Users from './pages/user';
import UsersAbout from './pages/aboutuser';
// Import pages
import Dashboard from './pages/Dashboard';
import NewUser from './pages/account/newuser';
import AuthPage from './pages/AuthPage';
import ProtectedRoute from './utils/ProtectedRoute';
import ForgotPassword from './pages/ForgotPassword';
import { ToastProvider } from './components/ui/ToastContext';
import Cities from './pages/spaces/cities';
import Regions from './pages/spaces/regions';
import NewPlace from './pages/spaces/newplace';
import EditPlace from './pages/spaces/editcities';
import Producers from './pages/producers/Producers';
import NewProducers from './pages/producers/newproducer';
import EditProducer from './pages/producers/editproducers';
import Institutions from './pages/institute/institution';
import NewInstitution from './pages/institute/newinstitution';
import Institutionsgroup from './pages/institute/institutiongrupttip.jsx';
import EditInstitution from './pages/institute/editinstitution';
import Product from './pages/producers/Product.jsx';
import NewProduct from './pages/producers/newproduct';
import EditProduct from './pages/producers/editproduct';
import Physicians from './pages/physicians/physicians';
import Speciality from './pages/physicians/speciality.jsx';
import NewPhysicians from './pages/physicians/newphysicians';
import PhysiciansAbout from './pages/physicians/aboutphysicians';
import Material from './pages/producers/Material';
import Typeactivity from './pages/activity/typeactivity';
import Planning from './pages/planning/Planning';
import EditPlanning from './pages/planning/editplanning';
import NewPlanning from './pages/planning/newplanning';
import CopyPlanning from './pages/planning/copyplanning';
import ViwePlanning from './pages/planning/viweplanning';
import ReportotherPlanning from './pages/planning/reportotherplanning';
import ReportPlanning from './pages/planning/reportplanning';
import Reporting from './pages/reporting/reporting';
import EditReporting from './pages/reporting/editreporting';
import NewReporting from './pages/reporting/newreporting';
import CopyReporting from './pages/reporting/copyreporting';
import ViweReporting from './pages/reporting/viwereporting';
import Otheractivity from './pages/otheractivity/otheractivity';
import NewOtheractivity from './pages/otheractivity/newotheractivity';
import EditOtheractivity from './pages/otheractivity/editotheractivity';
import ViweOtheractivity from './pages/otheractivity/viweotheractivity';
import { AuthProvider } from './pages/AuthContext.jsx';
import Timetracking from './pages/timetracking/timetracking.jsx';
import ErrorBoundary from './ErrorBoundary.jsx';
import MarketingConsentPage from './pages/MarketingConsentPage.jsx';
import MarketingConsentUnsubscribePage from './pages/MarketingConsentUnsubscribePage.jsx';
import MarketingConsentNotaInformarePage from './pages/MarketingConsentNotaInformarePage.jsx';
import MarketingConsent from './pages/marketing/MarketingConsent.jsx';

function App() {
  const location = useLocation();
const navigate = useNavigate();

  useEffect(() => {
    document.querySelector('html').style.scrollBehavior = 'auto';
    window.scroll({ top: 0 });
    document.querySelector('html').style.scrollBehavior = '';
  }, [location.pathname]); // triggered on route change

  useEffect(() => {
  const token = localStorage.getItem('jwtToken');
  const isAuthPage = location.pathname === '/' || location.pathname === '/forgot-password';
  const isPublicPage = isAuthPage || location.pathname.startsWith('/marketing-consent');
  
  if (token) {
    // Dacă există token, asigură-te că nu ești pe pagini de auth
    if (isAuthPage) {
      navigate('/dashboard', { replace: true });
    }
  } else {
    // Dacă nu există token, asigură-te că ești pe auth page
    if (!isPublicPage) {
      navigate('/', { replace: true });
    }
  }
}, [location.pathname, navigate]);

  return (
    <ErrorBoundary>
    <ToastProvider>
      <Routes>
        <Route exact path="/" element={<AuthPage />} />
        <Route exact path="/forgot-password" element={<ForgotPassword />} />
        <Route exact path="/marketing-consent" element={<MarketingConsentPage />} />
        <Route exact path="/marketing-consent/unsubscribe" element={<MarketingConsentUnsubscribePage />} />
        <Route exact path="/marketing-consent/nota-de-informare" element={<MarketingConsentNotaInformarePage />} />

        <Route
          path="/*"
          element={
            <AuthProvider>
              <Routes>
                <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
                <Route exact path="/users" element={<ProtectedRoute element={<Users />} />} />
                <Route exact path="/users/aboutuser" element={<ProtectedRoute element={<UsersAbout />} />} />
                <Route exact path="/users/createuser" element={<ProtectedRoute element={<NewUser />} />} />
                <Route exact path="/cities" element={<ProtectedRoute element={<Cities />} />} />
                <Route exact path="/regions" element={<ProtectedRoute element={<Regions />} />} />
                <Route exact path="/cities/createplace" element={<ProtectedRoute element={<NewPlace />} />} />
                <Route exact path="/cities/editplace" element={<ProtectedRoute element={<EditPlace />} />} />
                <Route exact path="/producers" element={<ProtectedRoute element={<Producers />} />} />
                <Route exact path="/producers/createproducer" element={<ProtectedRoute element={<NewProducers />} />} />
                <Route exact path="/producers/editproducer" element={<ProtectedRoute element={<EditProducer />} />} />
                <Route exact path="/institutions" element={<ProtectedRoute element={<Institutions />} />} />
                <Route exact path="/institutions/createinstitution" element={<ProtectedRoute element={<NewInstitution />} />} />
                <Route exact path="/institutiongrouptip" element={<ProtectedRoute element={<Institutionsgroup />} />} />
                <Route exact path="/institutions/editinstitution" element={<ProtectedRoute element={<EditInstitution />} />} />
                <Route exact path="/products" element={<ProtectedRoute element={<Product />} />} />
                <Route exact path="/products/createproduct" element={<ProtectedRoute element={<NewProduct />} />} />
                <Route exact path="/products/editproduct" element={<ProtectedRoute element={<EditProduct />} />} />
                <Route exact path="/physicians" element={<ProtectedRoute element={<Physicians />} />} />
                <Route exact path="/physicians/createphysician" element={<ProtectedRoute element={<NewPhysicians />} />} />
                <Route exact path="/physicians/editphysician" element={<ProtectedRoute element={<PhysiciansAbout />} />} />
                <Route exact path="/speciality" element={<ProtectedRoute element={<Speciality />} />} />
                <Route exact path="/materials" element={<ProtectedRoute element={<Material />} />} />
                <Route exact path="/typeactivity" element={<ProtectedRoute element={<Typeactivity />} />} />
                <Route exact path="/planning" element={<ProtectedRoute element={<Planning />} />} />
                <Route exact path="/planning/createplanning" element={<ProtectedRoute element={<NewPlanning />} />} />
                <Route exact path="/planning/editplanning" element={<ProtectedRoute element={<EditPlanning />} />} />
                <Route exact path="/planning/copyplanning" element={<ProtectedRoute element={<CopyPlanning />} />} />
                <Route exact path="/planning/viweplanning" element={<ProtectedRoute element={<ViwePlanning />} />} />
                <Route exact path="/planning/reportplanning" element={<ProtectedRoute element={<ReportPlanning />} />} />
                <Route exact path="/planning/reportotherplanning" element={<ProtectedRoute element={<ReportotherPlanning />} />} />
                <Route exact path="/reporting" element={<ProtectedRoute element={<Reporting />} />} />
                <Route exact path="/reporting/createreporting" element={<ProtectedRoute element={<NewReporting />} />} />
                <Route exact path="/reporting/editreporting" element={<ProtectedRoute element={<EditReporting />} />} />
                <Route exact path="/reporting/viwereporting" element={<ProtectedRoute element={<ViweReporting />} />} />
                <Route exact path="/reporting/copyreporting" element={<ProtectedRoute element={<CopyReporting />} />} />
                <Route exact path="/otheractivity" element={<ProtectedRoute element={<Otheractivity />} />} />
                <Route exact path="/otheractivity/createotheractivity" element={<ProtectedRoute element={<NewOtheractivity />} />} />
                <Route exact path="/otheractivity/editotheractivity" element={<ProtectedRoute element={<EditOtheractivity />} />} />
                <Route exact path="/otheractivity/viweotheractivity" element={<ProtectedRoute element={<ViweOtheractivity />} />} />
                <Route exact path="/timetracking" element={<ProtectedRoute element={<Timetracking />} />} />
                <Route exact path="/marketing/consent" element={<ProtectedRoute element={<MarketingConsent />} />} />

              </Routes>
            </AuthProvider>
          }
        />
      </Routes>
    </ToastProvider>
    </ErrorBoundary>

  )

  // return (
  //   <> 
  //   <ToastProvider>
  //     <AuthProvider>
  //       <Routes>
  //         <Route exact path="/" element={<AuthPage />} />
  //         <Route exact path="/forgot-password" element={<ForgotPassword />} />

  //         <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />

  //         {/* <Route exact path="/" element={<Dashboard />} /> */}
  //         <Route exact path="/users" element={<ProtectedRoute element={<Users />} />} />
  //         <Route exact path="/users/aboutuser" element={<ProtectedRoute element={<UsersAbout />} />} />
  //         <Route exact path="/users/createuser" element={<ProtectedRoute element={<NewUser />} />} />
  //         <Route exact path="/cities" element={<ProtectedRoute element={<Cities />} />} />
  //         <Route exact path="regions" element={<ProtectedRoute element={<Regions />} />} />
  //         <Route exact path="/cities/createplace" element={<ProtectedRoute element={<NewPlace />} />} />
  //         <Route exact path="/cities/editplace" element={<ProtectedRoute element={<EditPlace />} />} />
  //         <Route exact path="/producers" element={<ProtectedRoute element={<Producers />} />} />
  //         <Route exact path="/producers/createproducer" element={<ProtectedRoute element={<NewProducers />} />} />
  //         <Route exact path="/producers/editproducer" element={<ProtectedRoute element={<EditProducer />} />} />
  //         <Route exact path="/institutions" element={<ProtectedRoute element={<Institutions />} />} />
  //         <Route exact path="/institutions/createinstitution" element={<ProtectedRoute element={<NewInstitution />} />} />
  //         <Route exact path="/institutiongrouptip" element={<ProtectedRoute element={<Institutionsgroup />} />} />
  //         <Route exact path="/institutions/editinstitution" element={<ProtectedRoute element={<EditInstitution />} />} />
  //         <Route exact path="/products" element={<ProtectedRoute element={<Product />} />} />
  //         <Route exact path="/products/createproduct" element={<ProtectedRoute element={<NewProduct />} />} />
  //         <Route exact path="/products/editproduct" element={<ProtectedRoute element={<EditProduct />} />} />
  //         <Route exact path="/physicians" element={<ProtectedRoute element={<Physicians />} />} />
  //         <Route exact path="/physicians/createphysician" element={<ProtectedRoute element={<NewPhysicians />} />} />
  //         <Route exact path="/physicians/editphysician" element={<ProtectedRoute element={<PhysiciansAbout />} />} />
  //         <Route exact path="/speciality" element={<ProtectedRoute element={<Speciality />} />} />
  //         <Route exact path="/materials" element={<ProtectedRoute element={<Material />} />} />
  //         <Route exact path="/typeactivity" element={<ProtectedRoute element={<Typeactivity />} />} />
  //         <Route exact path="/planning" element={<ProtectedRoute element={<Planning />} />} />
  //         <Route exact path="/planning/createplanning" element={<ProtectedRoute element={<NewPlanning />} />} />
  //         <Route exact path="/planning/editplanning" element={<ProtectedRoute element={<EditPlanning />} />} />
  //         <Route exact path="/planning/copyplanning" element={<ProtectedRoute element={<CopyPlanning />} />} />
  //         <Route exact path="/planning/viweplanning" element={<ProtectedRoute element={<ViwePlanning />} />} />
  //         <Route exact path="/planning/reportplanning" element={<ProtectedRoute element={<ReportPlanning />} />} />
  //         <Route exact path="/planning/reportotherplanning" element={<ProtectedRoute element={<ReportotherPlanning />} />} />
  //         <Route exact path="/reporting" element={<ProtectedRoute element={<Reporting />} />} />
  //         <Route exact path="/reporting/createreporting" element={<ProtectedRoute element={<NewReporting />} />} />
  //         <Route exact path="/reporting/editreporting" element={<ProtectedRoute element={<EditReporting />} />} />
  //         <Route exact path="/reporting/viwereporting" element={<ProtectedRoute element={<ViweReporting />} />} />
  //         <Route exact path="/reporting/copyreporting" element={<ProtectedRoute element={<CopyReporting />} />} />
  //         <Route exact path="/otheractivity" element={<ProtectedRoute element={<Otheractivity />} />} />
  //         <Route exact path="/otheractivity/createotheractivity" element={<ProtectedRoute element={<NewOtheractivity />} />} />
  //         <Route exact path="/otheractivity/editotheractivity" element={<ProtectedRoute element={<EditOtheractivity />} />} />
  //         <Route exact path="/otheractivity/viweotheractivity" element={<ProtectedRoute element={<ViweOtheractivity />} />} />
  //       </Routes>
  //     </AuthProvider>
  //   </ToastProvider>
  //   </>
  // );
}

export default App;
